import { tw } from "@careinfo/tailwind";
import { memo } from "react";

export type EditorInfoProps = {
  characters: number;
  words: number;
};

export const EditorInfo = memo(({ characters, words }: EditorInfoProps) => {
  return (
    <div
      className={tw`flex flex-row justify-between pr-4 mr-4 text-right `}
    >
      <div className={tw`text-xs font-semibold text-neutral-500 `}>
        {words} {words === 1 ? "word" : "words"}
      </div>
      <div className={tw`text-xs font-semibold text-neutral-500`}>
        {characters} {characters === 1 ? "character" : "characters"}
      </div>
    </div>
  );
});

EditorInfo.displayName = "EditorInfo";
